export default __webpack_public_path__ + "static/media/japanday_2022.ea336ebe.png";